import { Circle, PauseCircle } from "@mui/icons-material";
import { Stack, SxProps, Typography } from "@mui/material";
import { StatusChangedDialogContent } from "src/components";
import { CommentSubject, ISSUE_STATUSES, IssueStatus } from "../../constants";

interface IProps {
  issueGuid: string;
  status: IssueStatus;
  hasDecision: boolean;
  onDone: () => void;
}

const IssueStatusChangedDialogContent = (props: IProps) => {
  function getIcon() {
    const iconSxProps: SxProps = {
      color: ISSUE_STATUSES.find((x) => x.id === props.status)!.color,
      width: 100,
      height: 100,
    };

    switch (props.status) {
      case IssueStatus.Paused:
        return <PauseCircle sx={iconSxProps} />;
      default:
        return <Circle sx={iconSxProps} />;
    }
  }

  return (
    <StatusChangedDialogContent
      icon={getIcon()}
      title={ISSUE_STATUSES.find((x) => x.id === props.status)!.name.toUpperCase()}
      content={
        <Stack>
          <Typography>
            You've marked this loop ${ISSUE_STATUSES.find((x) => x.id === props.status)!.name.toUpperCase()}.
          </Typography>
          <Typography>Please enter a comment with reasons for the change of status.</Typography>
        </Stack>
      }
      commentSubjectType={CommentSubject.Issue}
      commentSubjectGuid={props.issueGuid}
      onDone={props.onDone}
    />
  );
};

export { IssueStatusChangedDialogContent };
